module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921004149_T.2ac1696a.jpg";